import React, { FunctionComponent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGetBackofficeLandingsQuery } from 'services/exploreApi';
import { CommonHash } from 'app/types';
import Text from 'common/components/Text/Text';
import Table from 'common/components/NewTable/NewTable';
import Loader from 'common/components/Loader/Loader';

const columns = [
  { name: 'id', header: 'ID', type: 'number', defaultWidth: 60 },
  {
    name: 'name',
    defaultFlex: 1,
    header: 'Name',
  },
  {
    name: 'slug',
    defaultFlex: 1,
    header: 'Slug',
  },
  {
    name: 'status',
    defaultFlex: 1,
    header: 'Status',
  },
  {
    name: 'is_homepage',
    defaultFlex: 1,
    header: 'Is Homepage?',
  },
  {
    name: 'action',
    defaultFlex: 1,
    header: 'ACTIONS',
    render: ({ data }: { data: CommonHash }) => {
      return (
        <div style={{ display: 'flex', gap: '8px' }}>
          <Link to={`/backoffice/landings/${data.id}/preview`}>
            <i className="bi bi-eye" />
          </Link>
          <Link to={`/backoffice/landings/${data.id}/edit`}>
            <i className="bi bi-pencil-square" />
          </Link>
        </div>
      );
    },
  },
];

const defaultFilterValue = [
  { name: 'name', operator: 'contain', type: 'string', value: '' },
  { name: 'slug', operator: 'contain', type: 'string', value: '' },
  { name: 'status', operator: 'contain', type: 'string', value: '' },
  { name: 'is_homepage', operator: 'contain', type: 'string', value: '' },
];
const defaultSort = { name: 'created_at', dir: -1 };
const Landings: FunctionComponent = () => {
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(1);
  const [filterValue, setFilterValue] = useState(defaultFilterValue);
  const { data: landings, isLoading } = useGetBackofficeLandingsQuery({
    page_size: limit,
    page: page,
    query: JSON.stringify(filterValue),
  });
  const navigate = useNavigate();

  if (isLoading) return <Loader />;
  return (
    <div className="pt-3 w-100">
      <div className="ps-4">
        <Text size={30} weight={800}>
          Landings
        </Text>
      </div>
      <div className="d-flex justify-content-end me-4 mb-3">
        <button className="btn btn-success" onClick={() => navigate('new')}>
          Add Landing
        </button>
      </div>
      <Table
        columns={columns}
        data={landings ? landings.data : []}
        filters={filterValue}
        defaultSort={defaultSort}
        total={landings?.meta.total || 0}
        limit={limit}
        setLimit={setLimit}
        page={page}
        setPage={setPage}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default Landings;
